var _filter, _filter2, _linearGradient, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwiftcourseimg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 121,
    viewBox: "0 0 184 121",
    width: 184,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 24.3037,
    width: 24.302,
    x: 150.153,
    y: 9.95047
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.546079,
    dy: -0.546079
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.546079,
    dy: 0.546079
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow",
    mode: "normal",
    result: "effect2_innerShadow"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 65.6976,
    width: 66.3436,
    x: 128.584,
    y: -10.9999
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.4693
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.250017 0 0 0 0 0.215353 0 0 0 0 0.847968 0 0 0 0.610768 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 162.998,
    x2: 161.428,
    y1: 10.1132,
    y2: 34.0795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2fb8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9eecd9"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24.0275v24.0275h-24.0275z",
    transform: "matrix(.998361 .0654092 -.0577397 .997951 151.004 9.32736)"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h58.9766v92.8335h-58.9766z",
    transform: "matrix(1 0 -.00820296 .999966 11.8828 10.923)"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h40.4099v24.5736h-40.4099z",
    transform: "matrix(1 0 -.00820296 .999966 11.8828 10.923)"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h58.9765v39.3177h-58.9765z",
    transform: "matrix(1 0 -.00820296 .999966 11.4434 64.4369)"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h45.3246v19.6588h-45.3246z",
    transform: "matrix(1 0 -.00820296 .999966 11.2822 84.0951)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m161.611 34.0914c6.624.434 12.304-4.5819 12.687-11.2033s-4.676-12.3409-11.3-12.7749c-6.624-.43402-12.305 4.5819-12.688 11.2033s4.676 12.3409 11.301 12.7749z",
    fill: "url(#c)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m161.611 34.0914c6.624.434 12.304-4.5819 12.687-11.2033s-4.676-12.3409-11.3-12.7749c-6.624-.43402-12.305 4.5819-12.688 11.2033s4.676 12.3409 11.301 12.7749z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeOpacity: 0.3,
    strokeWidth: 0.27304
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m164.882 26.7678c-1.542.7763-3.599.7317-5.611-.3005-1.629-.8305-2.943-2.1834-3.748-3.6836.405.3885.887.7096 1.405.9967 2.073 1.1528 4.208 1.223 5.762.3801-.001-.001-.002-.0017-.002-.0027-2.037-1.7983-3.725-4.0804-4.974-5.9353-.268-.3071-.461-.6817-.655-1.0201 1.548 1.6214 4.033 3.7022 4.926 4.3038-1.835-2.2194-3.427-4.9293-3.36-4.8527 2.91 3.3755 5.686 5.3669 5.686 5.3669.092.0607.163.1109.219.1553.072-.1567.136-.3201.192-.4902.604-1.8061.157-3.9347-.988-5.7467 2.778 1.9553 4.293 5.384 3.421 8.1137-.023.0737-.048.1463-.073.2175.007.0106.015.0215.023.0327 1.317 1.896.816 3.7811.659 3.4089-.683-1.5813-2.138-1.2067-2.882-.9437z",
    fill: "#3913b8"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.9316 21.0903c1.6319 0 2.6449-.8204 2.6555-2.1167l.0001-.0046c.0083-1.0198-.59-1.5728-1.9702-1.8584l-.6924-.1405c-.7693-.1587-1.0845-.4125-1.081-.8386l.0001-.0045c.004-.4895.4553-.7978 1.1307-.8023.689 0 1.1396.3264 1.2128.7932l.0087.0544h1.2873l-.0041-.0589c-.0771-1.0924-.968-1.8992-2.4956-1.8992-1.4505 0-2.4997.8023-2.5096 2.0171l-.0001.0045c-.0081.9927.5714 1.6272 1.929 1.9037l.6879.1406c.81.1677 1.1298.4079 1.1263.8385v.0045c-.0042.5032-.5102.8522-1.24.8522-.766 0-1.2937-.3309-1.3395-.8204l-.0042-.0454h-1.319l.0039.0726c.0676 1.1603 1.0496 1.9082 2.6134 1.9082zm5.11-.1677h1.2918l1.2601-4.4058h.0725l1.2013 4.4058h1.2828l1.7898-6.5407h-1.4143l-1.0492 4.6733h-.0725l-1.1765-4.6733h-1.1558l-1.2305 4.6733h-.0726l-.9815-4.6733h-1.4233zm8.0368 0h1.3689l.0537-6.5407h-1.369zm2.9554 0h1.3689l.0212-2.5746h2.6608l.0089-1.0833h-2.6609l.0144-1.7541h2.9147l.0092-1.1287h-4.2835zm7.1348 0h1.3689l.0444-5.412h1.9627l.0093-1.1287h-5.2944l-.0093 1.1287h1.9628zm7.2784.1677c1.6862 0 2.7459-.9745 2.7578-2.425l.0351-4.2834h-1.3689l-.0342 4.1611c-.0069.8476-.5009 1.387-1.3803 1.387s-1.369-.5394-1.3621-1.387l.0342-4.1611h-1.369l-.0351 4.2834c-.0119 1.455 1.0453 2.425 2.7225 2.425zm4.3258-.1677h1.3689l.0536-6.5407h-1.3689z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.3789 33.3338c1.1161 0 1.9359-.6378 2.0894-1.598l.0002-.0208h-.7696l-.007.0139c-.1468.565-.6453.9185-1.3074.9185-.9012 0-1.4567-.7452-1.447-1.9306l.0001-.007c.0098-1.1889.5774-1.9341 1.4752-1.9341.6586 0 1.1579.3986 1.2985 1.0121l-.0001.0104h.7695l.0036-.0173c-.1235-.9948-.9636-1.6915-2.0659-1.6915-1.39 0-2.2613 1.0052-2.2746 2.6204v.007c-.0133 1.6118.8451 2.617 2.2351 2.617zm4.5932-.0486c.9637 0 1.4882-.5546 1.617-1.0502l.0072-.0312-.7245.0034-.0141.0278c-.0917.1941-.3813.4332-.8632.4332-.6204 0-1.0122-.4194-1.0201-1.1403h2.6691l.0021-.2635c.0093-1.13-.6292-1.889-1.6795-1.889s-1.7362.7868-1.7458 1.9618v.0035c-.0098 1.1924.6496 1.9445 1.7518 1.9445zm-.0076-3.2929c.5095 0 .8847.3259.9381.9983h-1.9134c.0712-.6482.4623-.9983.9753-.9983zm2.5595 3.2201h.7521l.0185-2.2495c.0045-.5442.3991-.8978.9745-.8978.1421 0 .2702.0174.4052.0451l.0056-.6933c-.0761-.0173-.2077-.0346-.329-.0346-.5026 0-.8546.2357-.9931.6343h-.0554l.0046-.5685h-.7522zm4.4574.0243c.1456 0 .2844-.0173.4059-.0381l.0049-.5997c-.104.0104-.1699.0139-.2843.0139-.3709 0-.5221-.1664-.5187-.5719l.0164-2h.8076l.0049-.5928h-.8077l.0078-.9497h-.766l-.0078.9497h-.5893l-.0049.5928h.5893l-.0179 2.1802c-.0059.7244.3314 1.0156 1.1598 1.0156zm1.7109-4.461c.2565 0 .4731-.2114.4752-.4679.0022-.26-.211-.4714-.4675-.4714-.26 0-.4732.2114-.4753.4714-.0021.2565.2076.4679.4676.4679zm-.4142 4.4367h.7487l.0309-3.7643h-.7488zm2.1109 0h.7488l.026-3.1715h.8284l.0049-.5928h-.8354l.003-.3604c.0031-.3813.1677-.5824.5836-.5824.1179 0 .2183.007.2876.0174l.0045-.5512c-.1281-.0208-.2735-.0346-.4434-.0346-.7834 0-1.1677.3674-1.1738 1.1161l-.0033.3951h-.6205l-.0048.5928h.6205zm2.8511-4.4367c.2565 0 .4731-.2114.4753-.4679.0021-.26-.2111-.4714-.4676-.4714-.26 0-.4732.2114-.4753.4714-.0021.2565.2076.4679.4676.4679zm-.4142 4.4367h.7487l.0309-3.7643h-.7488zm3.4276.0728c.9324 0 1.4738-.5026 1.615-1.2339l.0072-.0312h-.721l-.0071.0173c-.1246.4055-.4176.6204-.889.6204-.6205 0-1.0011-.506-.9942-1.3379v-.0069c.0067-.8111.3886-1.3103 1.016-1.3103.4991 0 .8019.2773.8821.6482l.0033.0104.7211-.0035.0001-.0173c-.098-.7314-.6586-1.2651-1.6049-1.2651-1.0989 0-1.774.7452-1.7837 1.9376l-.0001.0069c-.01 1.2166.6563 1.9653 1.7552 1.9653zm3.4976-.0104c.4991 0 .896-.2149 1.121-.5962h.0589l-.0043.5338h.7452l.0212-2.5754c.0064-.7902-.5235-1.2616-1.4698-1.2616-.8562 0-1.4523.4124-1.5475 1.0294l-.0037.0243h.7245l.0036-.0139c.0923-.2669.3674-.4194.7833-.4194.5096 0 .7677.2288.7643.6412l-.0027.3328-1.0196.0589c-.8983.0555-1.4075.4472-1.4131 1.1196v.0069c-.0056.6829.5211 1.1196 1.2387 1.1196zm-.4897-1.1507v-.007c.0028-.3397.24-.5268.7603-.558l.919-.059-.0026.3224c-.004.4853-.4195.8527-.9811.8527-.4055 0-.6985-.2045-.6956-.5511zm4.8922 1.1126c.1456 0 .2844-.0173.4059-.0381l.0049-.5997c-.1041.0104-.17.0139-.2843.0139-.3709 0-.5221-.1664-.5188-.5719l.0164-2h.8077l.0049-.5928h-.8077l.0078-.9497h-.7661l-.0078.9497h-.5892l-.0049.5928h.5893l-.0179 2.1802c-.0059.7244.3314 1.0156 1.1598 1.0156zm2.8212.0485c.9636 0 1.4881-.5546 1.617-1.0502l.0072-.0312-.7245.0034-.0141.0278c-.0917.1941-.3814.4332-.8632.4332-.6205 0-1.0122-.4194-1.0201-1.1403h2.669l.0022-.2635c.0093-1.13-.6293-1.889-1.6796-1.889-1.0502 0-1.7361.7868-1.7457 1.9618l-.0001.0035c-.0098 1.1924.6496 1.9445 1.7519 1.9445zm-.0076-3.2929c.5095 0 .8847.3259.9381.9983h-1.9134c.0711-.6482.4622-.9983.9753-.9983z",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    height: 2.18432,
    rx: 1.09216,
    transform: "matrix(1 0 -.00820296 .999966 11.4434 64.4369)",
    width: 58.9765
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.18432,
    rx: 1.09216,
    transform: "matrix(1 0 -.00820296 .999966 11.3896 70.9897)",
    width: 31.6726
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.18432,
    rx: 1.09216,
    transform: "matrix(1 0 -.00820296 .999966 11.3359 77.5424)",
    width: 42.5942
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.2,
    height: 2.18432,
    rx: 1.09216,
    transform: "matrix(1 0 -.00820296 .999966 11.2822 84.0951)",
    width: 31.6726
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.4,
    height: 4.36863,
    rx: 2.18432,
    transform: "matrix(1 0 -.00820296 .999966 11.1572 99.3848)",
    width: 45.3246
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiftcourseimg);
export default __webpack_public_path__ + "static/media/swiftcourseimg.feb09913d1000f56127be6093aae787a.svg";
export { ForwardRef as ReactComponent };